<template>
  <div id="app">
    <!-- <VantForm /> -->
   <keep-alive> <router-view></router-view></keep-alive>
   
  </div>
  
</template>

<script>
import VantForm from "@/components/vantForm";
export default {
  components: { VantForm },
  name: "App",
};
</script>

<style scoped lang="less">
</style>
